import { gql } from '@apollo/client';

const TASK_ASSOCIATE_REFERENCE_PHOTO = gql`
  mutation TaskAssociateReferencePhoto(
    $input: TaskAssociateReferencePhotoInput!
  ) {
    taskAssociateReferencePhoto(input: $input) {
      errors {
        error
        message
      }
      task {
        __typename
        id
        referencePhotos {
          id
          url
          thumbnailUrl
        }
      }
    }
  }
`;

export default TASK_ASSOCIATE_REFERENCE_PHOTO;
